import NavBar from "@components/navBar/NavBar";
import Footer from "@components/footer/Footer";
import React from "react";
import "./LegalNotices.scss";

export function LegalNotices() {
  return (
    <div id="legalNotices">
      <NavBar />
      <main>
        <div>
          <h1>Mentions légales</h1>
          <br />
          <h2><strong>Editeur Gestionnaire du site</strong></h2>
          <p><strong>Kilowattheure50</strong></p>
          <p>Société par actions simplifiée au capital de 1000 euros</p>
          <p>RCS Saint Brieuc 85024116700020</p>
          <p>N° TVA intracommunautaire : FR67850241167</p>
          <hr />
          <h2><strong>Siège social</strong></h2>
          <p>21, Rue de Broglie</p>
          <p>22300 LANNION</p>
          <hr />
          <h2><strong>Responsable de la publication</strong></h2>
          <p>SAS Kilowattheure50</p>
          <hr />
          <h2><strong>Hébergement</strong></h2>
          <p>OVH, 2 rue Kellermann 59100 Roubaix 1007</p>
          <hr />
          <h2><strong>Conception</strong></h2>
          <p>Studio Salé</p>
          <h2>Kilowattheure50</h2>
        </div>
      </main>
      <Footer />
    </div>
  )
}